<template>

    <div class="px-6 py-4 bg-minplan-beige -mb-4">
        <page-title :title="$t('agencies.edit')"></page-title>
    </div>

    <jet-form-section @submitted="editBuyer()">

        <template #form>

            <form-card :title="$t('agencies.name')">
                <div class="col-span-6">
                    <label for="name" class="block text-sm font-medium text-gray-700">{{
                            $t("agencies.name")
                        }} <RequiredMark /></label>
                    <input type="text" name="firstname" id="name" v-model="form.name"
                           class="mt-1 focus:ring-minplan-blue focus:border-minplan-blue block w-full shadow-sm sm:text-sm border-gray-300"
                           autofocus />
                    <jet-input-error :message="form.errors.name" class="mt-2" />
                </div>

            </form-card>
        </template>

        <template #actions>
            <div class="flex justify-end my-4 mx-6">

                <button @click="cancel" type="button"
                        class="inline-block uppercase font-semibold text-xs tracking-widest">
                    {{ $t("actions.cancel") }}
                </button>

                <primary-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing" class="ml-3 ">
                    {{ $t("actions.save") }}
                </primary-button>

            </div>
        </template>

    </jet-form-section>

</template>


<script>
import { defineComponent } from "vue";
import MainLayout from "@/Layouts/MainLayout";
import PrimaryButton from "@/Jetstream/PrimaryButton";
import JetSecondaryButton from "@/Jetstream/SecondaryButton";
import JetFormSection from "@/Jetstream/FormSection";
import JetInput from "@/Jetstream/Input";
import JetInputError from "@/Jetstream/InputError";
import JetLabel from "@/Jetstream/Label";
import PageTitle from "@/Shared/Components/PageTitle";
import { useForm } from "@inertiajs/inertia-vue3";
import { Switch, SwitchGroup, SwitchLabel } from "@headlessui/vue";
import FormCard from "@/Shared/Components/FormCard";
import RequiredMark from "@/Shared/Components/RequiredMark";

export default defineComponent({
    props: ["agency", "links"],
    inheritAttrs: false,
    layout: MainLayout,
    emits: ["closeModal"],
    components: {
        PageTitle,
        PrimaryButton,
        JetFormSection,
        JetInput,
        JetInputError,
        JetLabel,
        JetSecondaryButton,
        SwitchGroup,
        SwitchLabel,
        Switch,
        FormCard,
        RequiredMark
    },
    methods: {
        cancel() {
            this.$emit("closeModal");
        },
        editBuyer() {
            this.form.put(this.route(this.links.update, { agency: this.agency.uuid }), {
                preserveScroll: true,
                onSuccess: () => this.$notify({
                    group: "success",
                    title: "actions.success",
                    text: "agencies.updated"
                })
            });
        }
    },
    setup(props) {

        const form = useForm({
            name: props.agency.name
        });

        return { form };
    }
});
</script>

<style scoped></style>
